import type { EnemyDefinition, GameContent } from './world-types.js';

export function publicEnemy(definition: EnemyDefinition): EnemyDefinition {
  // A crew's difficulty, like resistances, is learned in play with Assess.
  const { profile: { resistances: _resistances, weaknesses: _weaknesses, ...profile }, encounterDifficulty: _difficulty, ...enemy } = structuredClone(definition);
  return { ...enemy, profile };
}

/** What a browser may know in advance. Encounter rewards and cache contents stay on the server and arrive only as visible containers; enemy resistances and weaknesses arrive only through Assess. */
export function publicContent(content: GameContent): GameContent {
  const { rewards: _rewards, caches: _caches, enemySummons: _summons, ...visible } = content;
  // Resistances and weaknesses are learned in play with Assess, never read from the stat block.
  return { ...visible, enemies: visible.enemies.map(publicEnemy) };
}
